import { supabase } from "./supabase";

const VISITOR_KEY = "aviacion_visitor_id";

/** Identificador anónimo y persistente del visitante (no contiene datos personales). */
function getVisitorId(): string {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `v_${Date.now()}_${Math.random().toString(36).slice(2)}`;
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "anon";
  }
}

/**
 * Registra una visita a una ruta del sitio.
 * Nunca lanza errores: el tracking no debe interrumpir la navegación.
 */
export async function trackVisit(path: string): Promise<void> {
  // No contabilizar el panel de administración.
  if (path.startsWith("/admin")) return;

  try {
    await supabase.from("page_visits").insert({
      path,
      visitor_id: getVisitorId(),
      referrer:
        typeof document !== "undefined" && document.referrer
          ? document.referrer
          : null,
    });
  } catch {
    // Silenciar cualquier error (RLS, red, tabla aún no creada, etc.).
  }
}
